import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Col, ControlLabel } from 'react-bootstrap'
import Select from 'react-select'
import editMerchant from './edit-merchant-hoc'
import MerchantInput from './merchant-input'
import { MIN_INVOICE_DUE_DAYS, MAX_INVOICE_DUE_DAYS } from '../../../utils/merchant'
import isEmpty from '../../../utils/isEmptyValue'
import InvoiceDeliveryTypes from '../../../utils/invoiceDeliveryTypes'
import CountryCodes from '../../../utils/country-codes-enum'

const invoiceDeliveryTypes = InvoiceDeliveryTypes()
const countryCodes = CountryCodes()

class InvoicingSettingsForm extends Component {
    onSettingsChangeFromList = (select, key) => {
        const { onSettingsChange } = this.props
        if (select) {
            onSettingsChange('value', key)({ target: { value: select.value } })
        } else {
            onSettingsChange('value', key)({ target: { value: null } })
        }
    }

    render() {
        const { merchantSettings, onSettingsChange } = this.props
        const isEInvoiceIdMandatory = merchantSettings.invoiceDeliveryType === 'E-INVOICE'
        return (
            <div>
                <MerchantInput
                    required
                    controlId="companyRegistrationNumber"
                    label="Business ID"
                    value={merchantSettings.companyRegistrationNumber}
                    onChange={onSettingsChange('value', 'companyRegistrationNumber')}
                    placeholder="Org nr -  this is not the same as the VAT number"
                />
                <MerchantInput
                    required
                    type="text"
                    controlId="taxRegistrationNumber"
                    label="Tax Registration Number"
                    value={merchantSettings.taxRegistrationNumber}
                    onChange={onSettingsChange('value', 'taxRegistrationNumber')}
                />
                <MerchantInput
                    required
                    controlId="dueDaysInvoice"
                    type="number"
                    min={MIN_INVOICE_DUE_DAYS}
                    max={MAX_INVOICE_DUE_DAYS}
                    label="Payment Terms"
                    value={merchantSettings.dueDaysInvoice}
                    onChange={onSettingsChange('value', 'dueDaysInvoice')}
                    placeholder="Days"
                />
                <MerchantInput
                    required
                    type="email"
                    controlId="invoiceEmail"
                    label="Invoice email"
                    value={merchantSettings.invoiceEmail}
                    onChange={onSettingsChange('value', 'invoiceEmail')}
                    placeholder="Invoice email"
                />
                <MerchantInput
                    type="email"
                    controlId="invoiceEmailCopy"
                    label="Invoice email CC"
                    value={merchantSettings.invoiceEmailCopy}
                    onChange={onSettingsChange('value', 'invoiceEmailCopy')}
                />
                <MerchantInput
                    type="email"
                    controlId="invoiceEmailSecondCopy"
                    label="Invoice email CC2"
                    value={merchantSettings.invoiceEmailSecondCopy}
                    onChange={onSettingsChange('value', 'invoiceEmailSecondCopy')}
                />
                <MerchantInput
                    type="email"
                    controlId="invoiceEmailReminder"
                    label="Invoice email reminder"
                    value={merchantSettings.invoiceEmailReminder}
                    onChange={onSettingsChange('value', 'invoiceEmailReminder')}
                />
                <FormGroup
                    controlId="invoiceDeliveryType"
                    validationState={!isEmpty(merchantSettings.invoiceDeliveryType) ? null : 'error'}
                >
                    <Col componentClass={ControlLabel} sm={3}>
                        Invoice delivery type
                    </Col>
                    <Col sm={9}>
                        <Select
                            placeholder="Select invoice delivery type..."
                            value={merchantSettings.invoiceDeliveryType || ''}
                            options={invoiceDeliveryTypes}
                            onChange={(select) => this.onSettingsChangeFromList(select, 'invoiceDeliveryType')}
                        />
                    </Col>
                </FormGroup>
                <MerchantInput
                    required={isEInvoiceIdMandatory}
                    type="text"
                    controlId="eInvoiceId"
                    label="GLN number/Peppol ID/e-invoice ID"
                    value={merchantSettings.eInvoiceId}
                    onChange={onSettingsChange('value', 'eInvoiceId')}
                />
                <MerchantInput
                    type="text"
                    controlId="customInvoiceReference"
                    label="Custom Invoice Reference"
                    value={merchantSettings.customInvoiceReference}
                    onChange={onSettingsChange('value', 'customInvoiceReference')}
                />
                <MerchantInput
                    type="text"
                    controlId="budbeeAccountManager"
                    label="Budbee Account Manager"
                    value={merchantSettings.budbeeAccountManager}
                    onChange={onSettingsChange('value', 'budbeeAccountManager')}
                />
                <h4>Invoice address</h4>
                <hr />
                <FormGroup
                    controlId="invoiceCountry"
                    validationState={!isEmpty(merchantSettings.invoiceCountry) ? null : 'error'}
                >
                    <Col componentClass={ControlLabel} sm={3}>
                        Country
                    </Col>
                    <Col sm={9}>
                        <Select
                            value={merchantSettings.invoiceCountry || ''}
                            options={countryCodes}
                            placeholder="Select country..."
                            onChange={(select) => this.onSettingsChangeFromList(select, 'invoiceCountry')}
                        />
                    </Col>
                </FormGroup>
                <MerchantInput
                    required
                    type="text"
                    controlId="invoicePostalCode"
                    label="Postal Code"
                    value={merchantSettings.invoicePostalCode}
                    onChange={onSettingsChange('value', 'invoicePostalCode')}
                />
                <MerchantInput
                    required
                    type="text"
                    controlId="invoiceCity"
                    label="City"
                    value={merchantSettings.invoiceCity}
                    onChange={onSettingsChange('value', 'invoiceCity')}
                />
                <MerchantInput
                    required
                    type="text"
                    controlId="invoiceAddr1"
                    label="Address1"
                    value={merchantSettings.invoiceAddr1}
                    onChange={onSettingsChange('value', 'invoiceAddr1')}
                />
                <MerchantInput
                    type="text"
                    controlId="invoiceAddr2"
                    label="Address2"
                    value={merchantSettings.invoiceAddr2}
                    onChange={onSettingsChange('value', 'invoiceAddr2')}
                />
                <MerchantInput
                    type="text"
                    controlId="invoiceAddr3"
                    label="Address3"
                    value={merchantSettings.invoiceAddr3}
                    onChange={onSettingsChange('value', 'invoiceAddr3')}
                />
            </div>
        )
    }
}

export default editMerchant(InvoicingSettingsForm)

InvoicingSettingsForm.propTypes = {
    merchantSettings: PropTypes.object.isRequired,
    onSettingsChange: PropTypes.func.isRequired,
}
